import { render, staticRenderFns } from "./TopicsHeader.vue?vue&type=template&id=99f14da8&scoped=true"
import script from "./TopicsHeader.vue?vue&type=script&lang=js"
export * from "./TopicsHeader.vue?vue&type=script&lang=js"
import style0 from "./TopicsHeader.vue?vue&type=style&index=0&id=99f14da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99f14da8",
  null
  
)

export default component.exports